import React, { useEffect } from "react";
import { send } from "../../JOKI";
import { useAuthenticationStatus } from "../../services/Authentication/AuthenticationHooks";
import { Hero, Tile, Button, Footer, Header, Icon, Spinner } from "selfly-ui-react";

import "./view-login.scss";

export default function LoginView(props) {
    const [authStatus, renew] = useAuthenticationStatus();

    function login() {
        send({
            key: "login",
            to: "AuthenticationService",
        });
    }

    useEffect(() => {
        if (authStatus === "USER_NOT_AUTHENTICATED") {
            renew();
        }
    });

    return (
        <div className="view-login">
            <header className="se-header se-header--blue">
                <div className="se-header-content">
                    <div className="se-header-title">
                        <img
                            alt="logotype"
                            src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
                            className="se-logo selfly-logo"
                        ></img>
                        <h1 className="se-header-title-heading">{`Selfly Admin Portal`}</h1>
                    </div>
                </div>
            </header>
            <Hero 
                className="bg-top"
                image="https://cdn.selflystore.com/images-general/logos/Selfly_Store_Main_Picture_2024.png"
                size="lg"
            >
                {authStatus === "USER_AUTHENTICATION_IN_PROGRESS" && <AuthenticationLoading />}
                {authStatus === "USER_AUTHENTICATED" && (
                    <React.Fragment>
                        <Tile color="yellow">
                            <div className="icon-container">
                                <Icon size="lg">warning</Icon>
                            </div>
                        </Tile>
                        <Tile color="yellow">
                            <div className="text-container">
                                <p>You are already logged in, please continue to the main page.</p>
                            </div>
                        </Tile>
                        <Tile>
                            <div className="login-container">
                                <Button onClick={login}>Main page</Button>
                            </div>
                        </Tile>

                    </React.Fragment>
                )}
                {(authStatus === "USER_NOT_AUTHENTICATED" || authStatus === "USER_AUTHENTICATION_FAILED") && (
                    <React.Fragment>
                        <Tile color="yellow">
                            <div className="icon-container">
                                <Icon size="lg">lock</Icon>
                            </div>
                        </Tile>
                        <Tile color="yellow">
                            <div className="text-container">
                                <p className="italic">
                                    Your session has been expired. Please sign in again.
                                </p>
                                <p>You need to be signed in to continue. Click the button to sign in.</p>
                            </div>
                        </Tile>
                        <Tile>
                            <div className="login-container">
                                <Button onClick={login}>Sign in</Button>
                            </div>
                        </Tile>
                    </React.Fragment>
                )}
            </Hero>

            <div className="content" />

        </div>
    );
}

export function AuthenticationLoading(props) {
    return (
        <React.Fragment>
            <Tile color="yellow">
                <div className="icon-container">
                    <Icon size="lg">lock</Icon>
                </div>
            </Tile>
            <Tile color="yellow">
                <div className="text-container">
                    <p>
                        <strong>Authentication redirect in progress.</strong>
                    </p>
                    <p>Please wait...</p>
                </div>
            </Tile>
            <Tile>
                <div className="spinner-container">
                    <Spinner />
                </div>
            </Tile>
        </React.Fragment>
    );
}
